import { ACCESS_COMPLETE_RECEIVE } from '../modules/auth';
import {
  getAuthUserId as getAuthUserIdFromState,
  getAuthEmail as getAuthEmailFromState,
} from '../modules/root-reducer';
import { setUnreadCount } from '../modules/intercom';
import getLog from '../../../server/logging/logger';

const log = getLog('intercom');

export const server =
  ({
    createUser,
    getAuthUserId = getAuthUserIdFromState,
    getAuthEmail = getAuthEmailFromState,
  }) =>
  ({ getState }) =>
  (next) =>
  (action) => {
    if (action.type !== ACCESS_COMPLETE_RECEIVE) {
      return next(action);
    }
    const res = next(action);

    try {
      createUser({
        user_id: getAuthUserId(getState()),
        email: getAuthEmail(getState()),
      });
    } catch (err) {
      log.warning('error creating user', { err });
    }

    return res;
  };

export const client =
  (w) =>
  ({ dispatch }) =>
  (next) => {
    w.Intercom('onUnreadCountChange', (unread) => {
      dispatch(setUnreadCount(unread));
    });
    return (action) => next(action);
  };
